import { render, staticRenderFns } from "./Accessibilita.vue?vue&type=template&id=98689c40"
import script from "./Accessibilita.vue?vue&type=script&lang=js"
export * from "./Accessibilita.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports